import { render, staticRenderFns } from "./DashboardPaslaugos.vue?vue&type=template&id=2d609eb9&scoped=true&"
import script from "./DashboardPaslaugos.vue?vue&type=script&lang=js&"
export * from "./DashboardPaslaugos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPaslaugos.vue?vue&type=style&index=0&id=2d609eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d609eb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VContainer,VDataTable,VTextField,VToolbar,VTooltip})
